/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
export const PREVIEW_THUMB_PX = 40;
const PDF_DOC_OPTIONS_WITH_CREDENTIALS = { withCredentials: true };
const PDF_DOC_OPTIONS_ANON = { withCredentials: false };
function PaperclipIcon() {
    return React.createElement("i", { className: "fa-light fa-paperclip qmb-ui-file-handler__row-icon", "aria-hidden": "true" });
}
function StatusIcon({ iconClass }) {
    return React.createElement("i", { className: `fa-light ${iconClass} qmb-ui-file-handler__row-icon`, "aria-hidden": "true" });
}
function ImageThumb({ src }) {
    const [failed, setFailed] = useState(false);
    if (failed)
        return React.createElement(PaperclipIcon, null);
    return (React.createElement("img", { src: src, alt: "", className: "qmb-ui-file-handler__row-thumbnail", "data-testid": "file-handler-image-thumb", onError: () => setFailed(true) }));
}
function isSameOriginUrl(url) {
    try {
        return new URL(url, window.location.href).origin === window.location.origin;
    }
    catch (_a) {
        return false;
    }
}
function PdfPageThumb({ url }) {
    const [failed, setFailed] = useState(false);
    const [ready, setReady] = useState(false);
    const [withCredentials, setWithCredentials] = useState(() => isSameOriginUrl(url));
    if (failed)
        return React.createElement(PaperclipIcon, null);
    return (React.createElement("div", { className: "qmb-ui-file-handler__pdf-thumb", "data-testid": "file-handler-pdf-thumb" },
        React.createElement(Document, { key: withCredentials ? 'cred' : 'anon', file: url, options: withCredentials ? PDF_DOC_OPTIONS_WITH_CREDENTIALS : PDF_DOC_OPTIONS_ANON, loading: React.createElement("i", { className: "fa-light fa-spinner fa-spin qmb-ui-file-handler__row-icon", "aria-hidden": "true" }), onLoadSuccess: () => setReady(true), onLoadError: () => {
                if (withCredentials) {
                    setReady(false);
                    setWithCredentials(false);
                    return;
                }
                setFailed(true);
            } }, ready ? (React.createElement(Page, { pageNumber: 1, width: PREVIEW_THUMB_PX, renderTextLayer: false, renderAnnotationLayer: false })) : null)));
}
/**
 * Table-cell preview: image thumb, first PDF page, or paperclip when neither is available.
 */
export function FilePreviewThumb({ kind, previewUrl, downloadUrl, statusIconClass }) {
    if (statusIconClass) {
        return React.createElement(StatusIcon, { iconClass: statusIconClass });
    }
    const visualUrl = previewUrl !== null && previewUrl !== void 0 ? previewUrl : downloadUrl;
    if (kind === 'photo' && visualUrl) {
        return React.createElement(ImageThumb, { src: visualUrl });
    }
    if (kind === 'pdf' && visualUrl) {
        return React.createElement(PdfPageThumb, { url: visualUrl });
    }
    return React.createElement(PaperclipIcon, null);
}
